const rankingItems = [
  { rank: 1, title: '鬼灭之刃', type: '日漫·热血', views: '980万', trend: 'up' },
  { rank: 2, title: '咒术回战', type: '日漫·战斗', views: '870万', trend: 'up' },
  { rank: 3, title: '我心属于你', type: '韩漫·恋爱', views: '820万', trend: 'up' },
  { rank: 4, title: '进击的巨人', type: '日漫·奇幻', views: '760万', trend: 'stable' },
  { rank: 5, title: '间谍过家家', type: '日漫·搞笑', views: '710万', trend: 'up' },
  { rank: 6, title: '秘密花园', type: '韩漫·悬疑', views: '650万', trend: 'down' },
  { rank: 7, title: '暗杀教室', type: '日漫·校园', views: '590万', trend: 'stable' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10">
          <div className="flex-1">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
              完结漫画热度榜
            </h2>
            <p className="text-sm text-foreground-500 mb-8">
              根据阅读量和讨论热度排名的完结漫画全集榜单，看看大家都在看什么
            </p>

            <div className="space-y-2">
              {rankingItems.map((item, i) => (
                <a
                  key={i}
                  href="#cards"
                  className="flex items-center gap-4 px-4 py-3 rounded-xl border border-background-200 bg-background-50 hover:border-primary-200 transition-colors cursor-pointer group"
                >
                  <span className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-500'
                  }`}>
                    {item.rank}
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">
                      {item.title}
                    </div>
                    <div className="text-xs text-foreground-400">{item.type}</div>
                  </div>
                  <div className="flex items-center gap-3 flex-shrink-0">
                    <span className="text-xs font-medium text-foreground-600">{item.views}</span>
                    <span className="w-5 h-5 flex items-center justify-center">
                      {item.trend === 'up' && <i className="ri-arrow-up-line text-accent-500 text-sm"></i>}
                      {item.trend === 'down' && <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>}
                      {item.trend === 'stable' && <i className="ri-subtract-line text-foreground-400 text-sm"></i>}
                    </span>
                  </div>
                </a>
              ))}
            </div>
          </div>

          <div className="lg:w-80 flex-shrink-0">
            <div className="bg-gradient-to-br from-primary-500/10 to-accent-500/10 rounded-2xl border border-background-200 p-6">
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-4">
                <i className="ri-fire-line text-lg"></i>
              </span>
              <h3 className="text-sm font-medium text-foreground-800 mb-2">热门趋势</h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-4">
                本周完结漫画热度持续攀升，热血战斗和恋爱校园类作品最受读者欢迎，下拉式全集阅读量环比增长35%。
              </p>
              <div className="space-y-2 text-xs text-foreground-600">
                <div className="flex justify-between">
                  <span>日漫全集占比</span>
                  <span className="font-medium text-primary-600">68%</span>
                </div>
                <div className="flex justify-between">
                  <span>韩漫全集占比</span>
                  <span className="font-medium text-accent-600">32%</span>
                </div>
                <div className="flex justify-between">
                  <span>日均阅读章节</span>
                  <span className="font-medium text-secondary-600">48万+</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}